import * as actions from '../actions/actionTypes';

const initialState = {
  directLanding: false, // to hit api when landing directly on a page with token (majorly reload of page)
  error: null, // to handle any error sent by api
  title: '', // title on first screen
  fullName: '', // name entered on first screen
  countryCode: '', // country code (mobile code) entered by user
  email: '', // user's email is
  mobile: '', // user entered mobile number
  token: '', // on submit of first api the generated token is stored in this field
  tncLink: '', // tnc link from response of first api
  businessTypeList: null, // to store the list of business type received in response of verify otp api
  docTypeList: null, // to store the list of type of supporting documents received in response of verify otp api
  status: '', // status of what screen to navigate to from second screen
  agencyName: '', // store user entered agency name
  panNumber: '', // pan Number
  panUploaded: false, // flag to tell if pan has been uploaded (is set to true on receiving success from uploadPAN api)
  panInfo: null, // stores the information sent in uploadPAN api response
  gstNumber: '', // selected GSTIN or the entered GSTIN
  businessType: '', // selected business type
  address: '', // entered address
  state: '', // state
  city: '', // city
  pincode: '', // pincode
  kycUploaded: false, // flag to tell if supporting document has been uploaded
  kycDocType: '', // type of document uploaded,
  facadeUploaded: false,
  registered: false,
  nextLoad: false,
  gstLoad: false,
  mobile_count: true,
  email_count: true,
  panSuccess: false, //flag to tell if name error is there after upload api response(set to true if uploadPan api error)
  pan_name: '', //flag to check error only for name issue
  user_msg: '',
  pan_type: false,
  prevPageName: '', // Previous page name, used to send to Omniture,
  accountId: '', // account id of the agent
  requestIp: '', // ip address of the request
  additionalDoc: '', //incase facade is not there
  btnDisabled: true, // to disabled the continue button on homescreen
  otpheading: '', // to store otp screen heading new flow
  otpSubheading: '', // to store otp screen sub heading
  exisitngUser: false, // to check for registered number
  nextScreen: '', // to check which screen to show next
  mpnfo: false, // to pass omniture value
  nof: false, // to redirect user for A/B
  loginLoad: false, // for loader on home continue
  user_country: false,
  country: false, //for storing the user country
  auth_token: '', //for storing the mmt auth after the create password step
  ed_license_number: '',
  agency_name: '',
  lob: '',
  formFieldData: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.UPDATE_TOKEN:
    case actions.UPDATE_INITIAL_DATA:
    case actions.REGISTER_USER_DATA_SUCCESS:
    case actions.REGISTER_USER_DATA_ERROR:
    case actions.VERIFY_OTP_ERROR:
    case actions.VERIFY_OTP_SUCCESS:
    case actions.UPADTE_PAN_INFO_SUCCESS:
    case actions.UPADTE_PAN_INFO_ERROR:
    case actions.RESET_PAN_INFO:
    case actions.UPLOAD_KYC_SUCCESS:
    case actions.UPLOAD_KYC_ERROR:
    case actions.UPLOAD_FACADE_SUCCESS:
    case actions.UPLOAD_FACADE_ERROR:
    case actions.SUBMIT_SUCCESS:
    case actions.SUBMIT_FAIL:
    case actions.SET_USER_CREDENTIALS:
    case actions.SET_USER_CREDENTIALS_ERROR:
    case actions.LOADING_FOR_NEXT:
    case actions.LOADING_FOR_KYCINFO:
    case actions.RESEND_COUNT:
    case actions.UPDATE_NAME_ISSUE:
    case actions.UPDATE_PREV_PAGE_NAME:
    case actions.RESET_INITIAL_DATA:
    case actions.UPDATE_MODAL_KYC:
    case actions.DISABLED_BUTTON:
    case actions.SEND_OTP_SUCCESS:
    case actions.VERIFY_MOBILE_OTP_SUCCESS:
    case actions.VERIFY_MOBILE_OTP_ERROR:
    case actions.KYCDOC_SUCCESS:
    case actions.LOADER_LOGIN_HOME:
    case actions.CHANGE_USER_COUNTRY:
    case actions.UPADTE_PASSPORT_INFO_ERROR:
      return {...state, ...action};
    case actions.UPDATE_FORMFIELD_DATA_LOGIN:
      return {
        ...state,
        formFieldData: {
          ...state.formFieldData,
          ...action?.payload,
        },
      };
    case actions.UPDATE_LOB:
      return {
        ...state,
        lob: action?.payload,
      };
    default:
      return state;
  }
};

export default reducer;
